import {addFrequency} from '../../../utils/recurrence'

export interface NewBankBill {
  contactId: string
  contactName: string
  description: string
  reference: string
  taxType: '' | 'GST' | 'GST_FREE' | 'NONE'
  recurring: boolean
  frequency: string
  nextDate: string
}
export function nextGenerationAfterPayment(paymentDate: string, frequency: string, today: string) {
  let next = addFrequency(paymentDate, frequency, paymentDate)
  for (let n = 0; next <= today && n < 5200; n++) next = addFrequency(next, frequency, paymentDate)
  if (next <= today) throw new Error('Payment is too old to calculate a future schedule')
  return next
}
export const billCredits = (b: any) =>
  b.amountCredited ??
  Math.max(0, Math.round(((b.total || 0) - (b.amountPaid || 0) - (b.amountDue || 0)) * 100) / 100)
export const canMatchBillAmount = (b: any) =>
  ['APPROVED', 'SENT'].includes(b.status) && !!b.lineItems?.length && !!b.revision
